var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "android"
  }, /*#__PURE__*/React.createElement("g", {
    id: "android_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8009 4.628C13.7477 4.09921 14.8388 3.79785 16.0002 3.79785C17.1617 3.79785 18.2527 4.09921 19.1995 4.628L19.8922 3.93531C20.0754 3.75203 20.3726 3.75203 20.5559 3.93531C20.7391 4.11859 20.7391 4.41574 20.5559 4.59902L19.9998 5.15505C21.563 6.35614 22.5706 8.24451 22.5706 10.3682H9.42984C9.42984 8.24451 10.4374 6.35614 12.0006 5.15505L11.4445 4.59902C11.2613 4.41574 11.2613 4.11859 11.4445 3.93531C11.6278 3.75203 11.925 3.75203 12.1083 3.93531L12.8009 4.628ZM14.123 7.55234C14.123 8.07073 13.7027 8.49097 13.1843 8.49097C12.6659 8.49097 12.2457 8.07073 12.2457 7.55234C12.2457 7.03396 12.6659 6.61372 13.1843 6.61372C13.7027 6.61372 14.123 7.03396 14.123 7.55234ZM18.8161 8.49097C19.3345 8.49097 19.7547 8.07073 19.7547 7.55234C19.7547 7.03396 19.3345 6.61372 18.8161 6.61372C18.2977 6.61372 17.8774 7.03396 17.8774 7.55234C17.8774 8.07073 18.2977 8.49097 18.8161 8.49097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67535 12.7148C5.67535 11.9372 6.30571 11.3068 7.08329 11.3068C7.86087 11.3068 8.49122 11.9372 8.49122 12.7148V18.3465C8.49122 19.1241 7.86087 19.7544 7.08329 19.7544C6.30571 19.7544 5.67535 19.1241 5.67535 18.3465V12.7148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2457 23.5089V26.7941C12.2457 27.5717 12.8761 28.202 13.6536 28.202C14.4312 28.202 15.0616 27.5717 15.0616 26.7941V23.5089H16.9388V26.7941C16.9388 27.5717 17.5692 28.202 18.3468 28.202C19.1243 28.202 19.7547 27.5717 19.7547 26.7941V23.5089H20.6933C21.7301 23.5089 22.5706 22.6685 22.5706 21.6317V11.3068H9.42984V21.6317C9.42984 22.6685 10.2703 23.5089 11.3071 23.5089H12.2457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5092 12.7148C23.5092 11.9372 24.1395 11.3068 24.9171 11.3068C25.6947 11.3068 26.3251 11.9372 26.3251 12.7148V18.3465C26.3251 19.1241 25.6947 19.7544 24.9171 19.7544C24.1395 19.7544 23.5092 19.1241 23.5092 18.3465V12.7148Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/android-icon.992b63dd77dfb7b7e26a210fdeca7348.svg";
export { ForwardRef as ReactComponent };